import {StockTakeData} from "./stock-take.data";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class StockTakeEntityModel extends EntityModel<StockTakeData> {
    constructor(injector: Injector) {
        super(injector, StockTakeData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
